<template>
  <v-container fluid class="pa-4">
    <v-row justify="center">
      <v-col cols="12" md="8" lg="6">
        <v-card>
          <v-card-title class="primary white--text d-flex align-center">
            Sincronização de Dados
          </v-card-title>
          
          <v-divider></v-divider>
          
          <v-list dense class="pa-0">

            <div class="text-center mt-4 mb-4">
              <v-btn 
                :loading="loadingGeral" 
                :disabled="loadingGeral"
                color="primary" 
                outlined
                @click="dialog = true"
              >
                <template v-slot:loader>
                  <v-progress-circular 
                    indeterminate 
                    color="primary" 
                    size="18"
                  ></v-progress-circular>
                </template>
                <v-icon left>mdi-sync</v-icon>
                Carga Total
              </v-btn>
            </div>
            <v-divider></v-divider>

            <template v-for="(item, index) in items">
              <v-list-item :key="item.key" :disabled="loadingGeral || item.loading" class="pt-1 pb-1">
                <v-list-item-icon>
                  <v-icon v-text="item.icon" :color="getStatusColor(item)"></v-icon>
                </v-list-item-icon>
                
                <v-list-item-content>
                  <v-list-item-title class="text-subtitle-1">
                    {{ item.title }}
                  </v-list-item-title>
                  
                  <v-list-item-subtitle 
                    v-if="item.statusMsg"
                    :class="`${getStatusColor(item)}--text`"
                    class="font-weight-medium"
                  >
                    {{ item.statusMsg }}
                  </v-list-item-subtitle>
                  
                  <v-progress-linear
                    v-if="item.loading"
                    indeterminate
                    color="primary"
                    height="4"
                    class="mt-1"
                  ></v-progress-linear>
                </v-list-item-content>

                <v-list-item-action>
                  <v-icon v-if="item.done" color="success">mdi-check</v-icon>
                  <v-icon v-else-if="item.error" color="error">mdi-alert-circle</v-icon>

                  </v-list-item-action>
              </v-list-item>
              <v-divider v-if="index < items.length - 1" :key="`div-${index}`"></v-divider>
            </template>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    
    <v-dialog 
      v-model="dialog"
      max-width="450"
    >
      <v-card>
        <v-card-title class=" primary white--text">
          Confirmação de Carga Total
        </v-card-title>
        
        <v-card-text class="pt-4 pb-0 text-body-1 black--text">
          <p>Você tem certeza que deseja realizar a Carga Total?</p>
          <p class="font-weight-medium">Isso pode levar alguns minutos.</p>
          <p class="font-weight-medium">Não saia da tela.</p>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            color="black" 
            text 
            @click="dialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn 
            color="white"
            class="primary" 
            text 
            @click="iniciarSincronizacaoConfirmada"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogErro" max-width="500">
      <v-card>
        <v-card-title class="error white--text">
          <v-icon left color="white">mdi-alert-circle-outline</v-icon>
          Falha na Conexão
        </v-card-title>

        <v-card-text class="pt-5 text-body-1">
          {{ msgErro }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogErro = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import db from '@/plugins/dexie';
import { VENDEDOR_STORAGE } from '@/constants/STORAGE';

export default {
  name: 'ViewCargaTotal',
  data() {
    return {
      baseUrl: '', 
      idVendedor: 0,
      senha: '',
      loadingGeral: false,
      dialog: false,
      abortController: null, 
      dialogErro: false,
      msgErro: '',
      
      items: [
        { key: 'empresa', title: 'Empresa', icon: 'mdi-domain', loading: false, done: false, error: false, statusMsg: '' },
        { key: 'vendedor', title: 'Vendedores', icon: 'mdi-account-tie', loading: false, done: false, error: false, statusMsg: '' },
        { key: 'plano', title: 'Planos de Pagamento', icon: 'mdi-credit-card-outline', loading: false, done: false, error: false, statusMsg: '' },
        { key: 'tipo', title: 'Tipos de Pedido', icon: 'mdi-tag-outline', loading: false, done: false, error: false, statusMsg: '' },
        { key: 'cliente', title: 'Clientes', icon: 'mdi-account-group', loading: false, done: false, error: false, statusMsg: '' },
        { key: 'produto', title: 'Produtos', icon: 'mdi-package-variant', loading: false, done: false, error: false, statusMsg: '' },
        { key: 'imagem', title: 'Imagens', icon: 'mdi-image', loading: false, done: false, error: false, statusMsg: '' },
        { key: 'grupo', title: 'Grupos de Produtos', icon: 'mdi-format-list-bulleted-type', loading: false, done: false, error: false, statusMsg: '' },
        { key: 'sugerido', title: 'Produtos Sugeridos', icon: 'mdi-lightbulb-on', loading: false, done: false, error: false, statusMsg: '' },
        { key: 'forma', title: 'Formas de Pagamento', icon: 'mdi-cash', loading: false, done: false, error: false, statusMsg: '' },
        { key: 'destino', title: 'Destinos', icon: 'mdi-map-marker', loading: false, done: false, error: false, statusMsg: '' },
        { key: 'venda', title: 'Histórico de Vendas', icon: 'mdi-chart-line', loading: false, done: false, error: false, statusMsg: '' },
        { key: 'financeiro', title: 'Financeiro', icon: 'mdi-currency-usd', loading: false, done: false, error: false, statusMsg: '' },
        { key: 'pedido', title: 'Status de Pedidos', icon: 'mdi-clipboard-text-clock-outline', loading: false, done: false, error: false, statusMsg: '' },
      ],
    };
  },

  async mounted() {
    await this.garantirConfiguracaoMinima();
    await this.carregarConfiguracoes();
  },

  methods: {
    formatarDataSQL(dataInput) {
      if (!dataInput) return null;
      
      const d = new Date(dataInput);
      if (isNaN(d.getTime())) return null;

      const ano = d.getFullYear();
      const mes = String(d.getMonth() + 1).padStart(2, '0');
      const dia = String(d.getDate()).padStart(2, '0');
      const horas = String(d.getHours()).padStart(2, '0');
      const minutos = String(d.getMinutes()).padStart(2, '0');
      const segundos = String(d.getSeconds()).padStart(2, '0');
      return `${ano}-${mes}-${dia}T${horas}:${minutos}:${segundos}`;
    },

    async obterParametroDataCarga() {
      try {
        const registroEmpresa = await db.empresa.limit(1).first();
        if (registroEmpresa && registroEmpresa.DataCargaItensTablet) {
          const dataCarga = new Date(registroEmpresa.DataCargaItensTablet);
          if (!isNaN(dataCarga.getTime())) {
            const offset = dataCarga.getTimezoneOffset() * 60000;
            const dataCargaFormatada = new Date(dataCarga.getTime() - offset).toISOString().slice(0, -1);
            return `&DataCargaItensTablet=${dataCargaFormatada}`;
          }
        }
      } catch (err) {
        // console.warn("Erro ao ler DataCargaItensTablet:", err);
      }
      return '';
    },

    async garantirConfiguracaoMinima() {
      try {
        const count = await db.parametro.count();
        if (count === 0) {
          await db.parametro.add({
            // linkwebservice: 'http://localhost:3001/', 
            empresa: 'Configuração Inicial',
            datainportacao: new Date(),
            pardataalteracao: new Date()
          });
        }
      } catch (e) {
        // console.error("Erro ao criar configuração mínima:", e);
      }
    },

    async carregarConfiguracoes() {
      try {
        const params = await db.parametro.toArray();
        
        if (params.length > 0) {
          const param = params[params.length - 1]; 
          
          const urlDoBanco = param.linkwebservice;

          if (urlDoBanco && urlDoBanco.trim().length > 0) {
            this.baseUrl = urlDoBanco.trim();
            
            if (!this.baseUrl.endsWith('/')) {
                this.baseUrl += '/';
            }
          }
        } else {
            // console.warn("Nenhum registro encontrado na tabela parametro.");
        }

        const userIdStorage = sessionStorage.getItem(VENDEDOR_STORAGE.venidnuvem);
        if (userIdStorage && userIdStorage !== 'null' && userIdStorage !== 'undefined') {
          const idParseado = parseInt(userIdStorage);
          if (!isNaN(idParseado)) {
            let user = await db.vendedor.where('idvendedor').equals(idParseado).first();
            if (!user) user = await db.vendedor.where('idvendedor').equals(userIdStorage).first();

            if (user) {
              this.idVendedor = parseInt(user.idvendedor) || parseInt(user.codigo);
              this.senha = user.senha || ''; 
            }
          }
        }
      } catch (err) {
        // console.error("Erro ao carregar configurações do Dexie:", err);
      }
    },

    getStatusColor(item) {
      if (item.error) return 'error';
      if (item.done) return 'success';
      if (item.loading) return 'primary';
      return 'grey';
    },

    async fetchWcf(metodo, params = '') {
      if (!this.baseUrl) {
        await this.carregarConfiguracoes();
        if (!this.baseUrl) throw new Error("URL da API não configurada no Banco de Dados.");
      }
      
      const url = `${this.baseUrl}${metodo}?ChaveSistema=m1cr0s3rv${params}`;
      
      const headers = {
        'Content-Type': 'application/json'
      };

      try {
        const registroEmpresa = await db.empresa.limit(1).first();
        
        if (registroEmpresa && registroEmpresa.EMPChaveAppVenda) {
          headers['Authorization'] = registroEmpresa.EMPChaveAppVenda;
        }
      } catch (err) {
        console.warn("Não foi possível recuperar a chave da empresa do banco local:", err);
      }

      try {
        const response = await fetch(url, { 
          signal: this.abortController.signal,
          headers: headers 
        });
        
        if (!response.ok) {
          if (response.status === 404) throw new Error(`Rota não encontrada: ${metodo}`);
          if (response.status === 401) throw new Error(`Acesso Negado (Chave Inválida): ${metodo}`);
          throw new Error(`Erro HTTP: ${response.status}`);
        }
        return await response.json();
      } catch (err) {
        if (err.name === 'AbortError') throw new Error('Cancelado');
        if (err.message.includes('Failed to fetch')) {
            throw new Error(`Sem conexão com ${this.baseUrl}. Verifique o servidor.`);
        }
        throw err;
      }
    },
    
    iniciarSincronizacaoConfirmada() {
      this.dialog = false;
      this.iniciarSincronizacaoTotal();
    },

    async iniciarSincronizacaoTotal() {
      if (this.loadingGeral) return;
      
      this.loadingGeral = true;
      this.abortController = new AbortController();
      
      this.items.forEach(item => {
        item.loading = false;
        item.done = false;
        item.error = false;
        item.statusMsg = '';
      });

      try {
        await this.processarItem('empresa', this.sincronizarDadosEmpresa);
        await this.processarItem('vendedor', this.sincronizarVendedores);
      
        await this.carregarConfiguracoes();

        await this.processarItem('plano', this.sincronizarPlanos);
        await this.processarItem('tipo', this.sincronizarTipos);
        await this.processarItem('cliente', this.sincronizarClientes);
        await this.processarItem('produto', this.sincronizarProdutos);
        await this.processarItem('imagem', this.sincronizarImagens); 
        await this.processarItem('grupo', this.sincronizarGrupo);
        await this.processarItem('sugerido', this.sincronizarSugeridos);
        await this.processarItem('forma', this.sincronizarFormas);
        await this.processarItem('destino', this.sincronizarDestinos);
        await this.processarItem('venda', this.sincronizarVendas);
        await this.processarItem('financeiro', this.sincronizarFinanceiro);
        await this.processarItem('pedido', this.atualizaPedido);

        if (this.idVendedor > 0 && this.$router) {
          this.$router.replace('/home'); 
          } else {
              this.$root.$emit('mostrarMsg', 'Sincronização concluída com sucesso!');
          }

      } catch (error) {
        if (error.message !== 'Cancelado') {
          this.msgErro = error.message;
          this.dialogErro = true;
        }
      } finally {
        this.loadingGeral = false;
      }
    },

    async processarItem(key, funcaoAssincrona) {
      const item = this.items.find(i => i.key === key);
      if (!item) return;

      item.loading = true;
      item.done = false;
      item.error = false;
      item.statusMsg = 'Baixando...';

      try {
        await funcaoAssincrona(item); 
        item.done = true;
        if (item.statusMsg === 'Baixando...') item.statusMsg = 'Concluído';
      } catch (err) {
        item.error = true;
        item.statusMsg = 'Erro';
        // console.error(`Erro em ${key}:`, err);
        throw err;
      } finally {
        item.loading = false;
      }
    },

    async baixarImagemBlob(baseUrl, caminhoImagem) {
      if (!caminhoImagem) return null;
      
      try {
        const urlLimpa = baseUrl.replace(/\/$/, '');
        const caminhoCodificado = encodeURIComponent(caminhoImagem);
        const urlCompleta = `${urlLimpa}/empresa/imagem?caminho=${caminhoCodificado}`;

        const response = await fetch(urlCompleta, {
          signal: this.abortController ? this.abortController.signal : undefined
        });
        
        if (!response.ok) {
          // eslint-disable-next-line no-console
          console.warn(`Aviso: Não foi possível baixar a imagem. Status: ${response.status}`);
          return null;
        }
        const json = await response.json();
        
        const base64 = json.data ? json.data.imagemBase64 : json.imagemBase64; 

        if (!base64) {
          // eslint-disable-next-line no-console
          console.warn("Base64 não encontrado no retorno da API.");
          return null;
        }

        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        
        const extensao = caminhoImagem.split('.').pop().toLowerCase();
        let mimeType = 'image/jpeg';
        if (extensao === 'png') mimeType = 'image/png';

        return new Blob([byteArray], { type: mimeType });

      } catch (error) {
        if (error.name === 'AbortError') throw error;
        // eslint-disable-next-line no-console
        console.error("Erro ao converter a imagem para Blob:", error);
        return null;
      }
    },

    // 0. EMPRESA
    async sincronizarDadosEmpresa(item) {
      const paramsDb = await db.parametro.toArray();
      const configAtual = paramsDb.length > 0 ? paramsDb[paramsDb.length - 1] : null;

      const dataDestaBaixa = new Date();

      // FORÇA A CARGA TOTAL: Limpa a tabela de empresa toda vez, seguindo a lógica de produto e cliente
      await db.empresa.clear();

      let dados = await this.fetchWcf('empresa/dados');

      if (dados && !Array.isArray(dados) && dados.data) {
        dados = dados.data;
      }

      if (!dados) {
        throw new Error("Sem dados de empresa.");
      }

      const e = Array.isArray(dados) ? dados[0] : dados;

      if (!e) {
        throw new Error("Nenhum registro de empresa encontrado.");
      }

      let blobImagemDuplicata = null;
      if (e.CaminhoImagemDuplicata) {
        blobImagemDuplicata = await this.baixarImagemBlob(this.baseUrl, e.CaminhoImagemDuplicata);
      }

      await db.empresa.put({
        idEmpresa: e.ID_Empresa,
        NomeEmpresa: e.NM_Empresa,
        NomeFantasia: e.NomeFantasia,
        Telefone: e.Telefone,
        TipoEmpresa: e.TP_Empresa,
        InscricaoEstadual: e.InscricaoEstadual || e.INSCESTADUAL,
        PedirCodigoProduto: e.PedirCodigoProduto,
        Email: e.Email,
        CEP: e.CEP,
        Cnpj: e.Cnpj,
        CpfCnpjFormatado: e.CPF_CNPJ,
        Endereco: e.Endereco,
        EnderecoCompleto: e.EnderecoCompleto,
        CidadeUF: e.CidadeUF,
        EMPChaveAppVenda: e.EMPChaveAppVenda,
        SenhaSmtpNfe: e.SenhaSmtpNfe,
        HostSmtpNfe: e.HostSmtpNfe,
        vendaprodutozerado: e.vendaprodutozerado,
        confirmavendaprodutozerado: e.confirmavendaprodutozerado !== undefined ? e.confirmavendaprodutozerado : e.confirmavendaprodutozerad,
        DataCargaItensTablet: e.DataCargaItensTablet,
        PortaSmtpNfe: e.PortaSmtpNfe,
        CaminhoImagemDuplicata: blobImagemDuplicata,
        CaminhoImagemDuplicataTexto: e.CaminhoImagemDuplicata, 
        databaixado: dataDestaBaixa 
      });

      if (configAtual) {
        const primKey = db.parametro.schema.primKey.name; 
        const keyVal = configAtual[primKey];
        await db.parametro.update(keyVal, { 
          databaixado_empresa: dataDestaBaixa 
        });
      }

      if (item) {
        item.statusMsg = e.NomeFantasia || e.NM_Empresa || 'Empresa atualizada';
      }
    },

    // 1. VENDEDORES
    async sincronizarVendedores(item) {
      const paramsDb = await db.parametro.toArray();
      const configAtual = paramsDb[0];
      
      let ultimaBaixa = configAtual ? configAtual.databaixado_vendedor : null;
      const dataDestaBaixa = new Date();

      let qtdVendedores = 0;

      const ajustarDataParaLocal = (date) => {
        const offset = date.getTimezoneOffset() * 60000;
        return new Date(date.getTime() - offset).toISOString().slice(0, -1);
      };

      if (!ultimaBaixa) await db.vendedor.clear();
      else ultimaBaixa = new Date(ultimaBaixa.getTime() - (30 * 60 * 1000));
      
      const ultimoVendedor = await db.vendedor.orderBy('idvendedor').last();
      const ultimoId = ultimoVendedor ? ultimoVendedor.idvendedor : 0;

      let paramsUrl = `&UltimoId=${ultimoId}`;
      if (ultimaBaixa) {
        paramsUrl += `&DataAlteracao=${ajustarDataParaLocal(ultimaBaixa)}`;
      }

      const dadosVendedores = await this.fetchWcf('vendedor/lista', paramsUrl);
      
      if (dadosVendedores && dadosVendedores.length > 0) {
        const vendedoresFormatados = dadosVendedores.map(v => ({
          idvendedor: v.IdVendedor, 
          codigo: v.Codigo, 
          nome: v.NomeVendedor,
          senha: v.Senha,
          cpf: v.CPF,
          valormeta: v.ValorMeta,
          databaixado: dataDestaBaixa
        })).filter(v => v.idvendedor !== null);

        qtdVendedores = vendedoresFormatados.length;

        await db.vendedor.bulkPut(vendedoresFormatados);
      }

      if (configAtual) {
        const primKey = db.parametro.schema.primKey.name; 
        const keyVal = configAtual[primKey];
        await db.parametro.update(keyVal, { 
          databaixado_vendedor: dataDestaBaixa 
        });
      }

      if (ultimaBaixa) {
          item.statusMsg = qtdVendedores > 0 
              ? `Atualizados: ${qtdVendedores}` 
              : 'Vendedores atualizado';
      } else {
          item.statusMsg = `Total: ${qtdVendedores} vendedores`;
      }
    },

    // 2. PLANOS
    async sincronizarPlanos(item) {
      const paramsDb = await db.parametro.toArray();
      const configAtual = paramsDb.length > 0 ? paramsDb[paramsDb.length - 1] : null;

      let ultimaBaixa = configAtual ? configAtual.databaixado_planopagamento : null;
      const dataDestaBaixa = new Date();

      const ajustarDataParaLocal = (date) => {
        const offset = date.getTimezoneOffset() * 60000;
        const dataLocal = new Date(date.getTime() - offset);
        return dataLocal.toISOString().slice(0, -1);
      };

      if (ultimaBaixa) ultimaBaixa = new Date(ultimaBaixa);

      if (!ultimaBaixa) {
        await db.planopagamento.clear();
      } else {
        const margemSeguranca = 30 * 60 * 1000; 
        ultimaBaixa = new Date(ultimaBaixa.getTime() - margemSeguranca);
      }
      
      const ultimoPlano = await db.planopagamento.orderBy('idplanopagto').last();
      const ultimoId = ultimoPlano ? ultimoPlano.idplanopagto : 0;

      let paramsUrl = `&UltimoId=${ultimoId}`;
      if (ultimaBaixa) {
        const dataFormatada = ajustarDataParaLocal(ultimaBaixa);
        paramsUrl += `&DataAlteracao=${dataFormatada}`;
      }
      
      const dados = await this.fetchWcf('planopagamento/', paramsUrl);

      if (!dados) {
        if (!ultimaBaixa) throw new Error("Sem dados de planos.");
        item.statusMsg = "Planos atualizados";
        return;
      }
      
      if (dados.length === 0) {
        if (!ultimaBaixa) item.statusMsg = "Nenhum plano encontrado.";
        else item.statusMsg = "Planos atualizados.";
      } else {
        const dadosFormatados = dados.map(p => ({
          idplanopagto: p.IdPlanoPagamento || p.IdPlanopag,
          descricao: p.Descricao,
          condicaovalorde: p.CondicaoValorDe || p.condicaovalorde,
          condicaovalorate: p.CondicaoValorAte || p.condicaovalorate,
          tipoplano: p.TipoPlano,
          databaixado: dataDestaBaixa 
        }))
        .filter(p => p.idplanopagto !== undefined && p.idplanopagto !== null);

        await db.planopagamento.bulkPut(dadosFormatados);
        
        if (ultimaBaixa) {
          item.statusMsg = `Atualizados: ${dadosFormatados.length}`;
        } else {
            item.statusMsg = `Total: ${dadosFormatados.length} planos`;
        }
      }

      if (configAtual) {
        const primKey = db.parametro.schema.primKey.name; 
        const keyVal = configAtual[primKey];

        await db.parametro.update(keyVal, { 
          databaixado_planopagamento: dataDestaBaixa 
        });
      }
    },

    // 3. TIPOS
    async sincronizarTipos(item) {
      const paramsDb = await db.parametro.toArray();
      const configAtual = paramsDb.length > 0 ? paramsDb[paramsDb.length - 1] : null;

      let ultimaBaixa = configAtual ? configAtual.databaixado_tipopedido : null;
      const dataDestaBaixa = new Date();

      const ajustarDataParaLocal = (date) => {
        const offset = date.getTimezoneOffset() * 60000;
        const dataLocal = new Date(date.getTime() - offset);
        return dataLocal.toISOString().slice(0, -1);
      };

      if (ultimaBaixa) ultimaBaixa = new Date(ultimaBaixa);

      if (!ultimaBaixa) {
        await db.tipopedidovenda.clear();
      } else {
        const margemSeguranca = 30 * 60 * 1000;
        ultimaBaixa = new Date(ultimaBaixa.getTime() - margemSeguranca);
      }
      
      const ultimoTipo = await db.tipopedidovenda.orderBy('idtipopedidovenda').last();
      const ultimoId = ultimoTipo ? ultimoTipo.idtipopedidovenda : 0;

      let paramsUrl = `&UltimoId=${ultimoId}`;
      if (ultimaBaixa) {
        const dataFormatada = ajustarDataParaLocal(ultimaBaixa);
        paramsUrl += `&DataAlteracao=${dataFormatada}`;
      }

      const dados = await this.fetchWcf('tipopedidovenda/', paramsUrl);

      if (!dados) {
        if (!ultimaBaixa) throw new Error("Sem dados");
        item.statusMsg = "Tipos atualizados";
        return;
      }
      
      if (dados.length === 0) {
        if (!ultimaBaixa) item.statusMsg = "Nenhum tipo encontrado.";
        else item.statusMsg = "Tipos atualizados.";
      } else {
        const dadosFormatados = dados.map(t => ({
          idtipopedidovenda: t.IDTipoPedidoVenda || t.id,
          descricao: t.Descricao,
          idplanopagto: t.IdPlanoPagto,
          idformapagto: t.IdFormaPagto,
          iddestinoitem: t.IdDestinoItem,
          databaixado: dataDestaBaixa
        }))
        .filter(t => t.idtipopedidovenda !== undefined && t.idtipopedidovenda !== null);

        await db.tipopedidovenda.bulkPut(dadosFormatados);
        
        item.statusMsg = ultimaBaixa 
            ? `Atualizados: ${dadosFormatados.length}`
            : `Total: ${dadosFormatados.length} tipos`;
      }

      if (configAtual) {
        const primKey = db.parametro.schema.primKey.name; 
        const keyVal = configAtual[primKey];
        await db.parametro.update(keyVal, { 
          databaixado_tipopedido: dataDestaBaixa 
        });
      }
    },

    // 4. CLIENTES
    async sincronizarClientes(item) {
      const paramsDb = await db.parametro.toArray();
      const configAtual = paramsDb.length > 0 ? paramsDb[paramsDb.length - 1] : null; 
      const idVendedorLogado = (configAtual && configAtual.idvendedorlogado) ? configAtual.idvendedorlogado : this.idVendedor;

      item.statusMsg = 'Verificando restrições...';
      try {
        await this.fetchWcf('cliente/verificar-todos', `&IdVendedor=${idVendedorLogado}`);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn('Erro ao verificar restrições:', err);
      }
      item.statusMsg = 'Baixando...';

      let ultimaSincronizacaoGlobal = configAtual ? configAtual.databaixado : null;

      ultimaSincronizacaoGlobal = null;

      const dataDestaBaixa = new Date();
      
      const ultimoVendedorSincronizado = configAtual ? configAtual.vendedor_sync_cliente : null;

      if (ultimoVendedorSincronizado !== idVendedorLogado) {
        ultimaSincronizacaoGlobal = null;
      }

      if (!ultimaSincronizacaoGlobal) {
        await db.cliente.clear();
      }
      
      const ultimoCliente = await db.cliente.orderBy('idcliente').last();
      const ultimoId = ultimoCliente ? ultimoCliente.idcliente : 0;
      
      let paginaAtual = 1;
      const limitePorPagina = 2000;
      let totalProcessado = 0;
      let continuar = true;

      const ajustarDataParaLocal = (date) => {
        const offset = date.getTimezoneOffset() * 60000;
        const dataLocal = new Date(date.getTime() - offset);
        return dataLocal.toISOString().slice(0, -1);
      };

      while (continuar) {
        let paramsUrl = `&page=${paginaAtual}&limit=${limitePorPagina}&UltimoId=${ultimoId}&IdVendedor=${idVendedorLogado}`;
        
        if (ultimaSincronizacaoGlobal) {
          const dataFormatada = ajustarDataParaLocal(ultimaSincronizacaoGlobal);
          paramsUrl += `&DataAlteracao=${dataFormatada}`;
        }

        const dados = await this.fetchWcf('cliente/lista', paramsUrl);

        if (dados && dados.length > 0) {
          const dadosFormatados = dados.map(c => ({
              idcliente: c.IdCliente, 
              idvendedor: c.IdVendedor, 
              nome: c.Nome,
              nomefantasia: c.Fantasia,
              endereco: c.Endereco,
              cidade: c.Cidade,
              bairro: c.Bairro,
              uf: c.UF,
              cep: c.Cep,
              cnpjCpf: c.CNPJ_CPF,
              inscricaoEstadual: c.InscricaoEstadual,
              fone: c.Fone,
              email: c.Email,
              bloqueado: c.Bloqueado,
              restricao: c.Restricao,
              limiteCredito: c.LimiteCredito,
              ultVDA: c.UltVDA,
              priVDA: c.PriVDA,
              qtdeVDA: c.qtdeVDA,
              DATAINATIVO: c.DATAINATIVO,
              DataCadastro: c.DataCadastro,
              idforma: c.Idforma,
              idplanopagto: c.IdPlanoPagto,
              databaixado: dataDestaBaixa 
          }));
          await db.cliente.bulkPut(dadosFormatados);
          
          totalProcessado += dadosFormatados.length;
          item.statusMsg = `Processando: ${totalProcessado}...`;
          
          if (dados.length < limitePorPagina) {
            continuar = false;
          } else {
            paginaAtual++;
          }
        } else {
          continuar = false;
        }
      }
      
      if (configAtual) {
        const primKey = db.parametro.schema.primKey.name; 
        const keyVal = configAtual[primKey];
        await db.parametro.update(keyVal, { 
          databaixado: dataDestaBaixa,
          vendedor_sync_cliente: idVendedorLogado 
        });
      }

      if (ultimaSincronizacaoGlobal) {
          item.statusMsg = totalProcessado > 0 
              ? `Atualizados: ${totalProcessado}` 
              : 'Clientes atualizados';
      } else {
          item.statusMsg = `Total: ${totalProcessado} clientes`;
      }
    },

    // 5. PRODUTOS
    async sincronizarProdutos(item) {
      const paramsDb = await db.parametro.toArray();
      const configAtual = paramsDb.length > 0 ? paramsDb[paramsDb.length - 1] : null;

      const dataDestaBaixa = new Date();

      // FORÇA A CARGA TOTAL: Limpa a tabela de produtos toda vez
      await db.produto.clear();

      let ultimoIdPagina = 0;
      let ultimoIdDexie = 0; // Sempre começa em 0 pois o banco foi limpo
      let totalBaixado = 0;
      let continuar = true;
      const limitePorPagina = 100;

      while (continuar) {
        // Removida a verificação e injeção do &DataAlteracao
        let paramsUrl = `&ultimoIdPagina=${ultimoIdPagina}&ultimoIdDexie=${ultimoIdDexie}&limite=${limitePorPagina}`;

        const dados = await this.fetchWcf('produto/lista', paramsUrl);

        if (dados && dados.length > 0) {
          const dadosFormatados = dados.map(p => {
            const idProd = p.IdProduto || p.idProduto || p.idproduto || p.IDPRODUTO || p.id || p.Id || p.ID || p.IdCortamanhofinal || p.idcortamanhofinal || p.idCortamanhofinal;
            const idCort = p.IdCortamanhofinal || p.idcortamanhofinal || p.idCortamanhofinal || p.IDCORTAMANHOFINAL || idProd;

            return {
              idproduto: idProd,
              idcortamanhofinal: idCort,
              status: p.status || p.Status || p.STATUS,
              codigointerno: p.CodigoInterno || p.codigoInterno || p.codigointerno,
              codigofuncao: p.Codigo || p.codigo || p.codigofuncao, 
              descricaogrupo: p.Grupo || p.grupo || p.descricaogrupo || '',
              descricao: p.Descricao || p.descricao,
              un: p.UM || p.um || p.Unidade || p.un,
              marca: p.Marca || p.marca,
              preco: p.Preco || p.preco,
              precoMinimo: p.PrecoMinimo || p.precoMinimo,
              estoque: p.Estoque || p.estoque,
              idgrupo: p.IdGrupo || p.idGrupo || p.idgrupo,
              pedepreco: p.pedepreco || p.PedePreco,
              detalheproduto: p.DetalheProduto || p.detalheProduto || p.detalheproduto,
              datainiciopromocao: p.DataInicioPromocao || p.dataInicioPromocao || p.datainiciopromocao,
              datafinalpromocao: p.DataFinalPromocao || p.dataFinalPromocao || p.datafinalpromocao,
              promocombo: p.PromocaoCombo || p.promocaoCombo || p.promocombo,
              qtdecombo: p.QtdeCombo || p.qtdeCombo || p.qtdecombo,
              precocombo: p.PrecoCombo || p.precoCombo || p.precocombo,
              ctfqtdecomboleva: p.CTFQtdeComboLeva || p.ctfQtdeComboLeva || p.ctfqtdecomboleva,
              temImagem: p.TemImagem || p.temImagem || p.temimagem,
              imagem1: p.Imagem1 || p.imagem1,
              imagem2: p.Imagem2 || p.imagem2,
              imagem3: p.Imagem3 || p.imagem3,
              imagem4: p.Imagem4 || p.imagem4,
              imagem5: p.Imagem5 || p.imagem5,
              imagem6: p.Imagem6 || p.imagem6,
              imagem7: p.Imagem7 || p.imagem7,
              imagem8: p.Imagem8 || p.imagem8,
              imagem9: p.Imagem9 || p.imagem9,
              imagem10: p.Imagem10 || p.imagem10,
              databaixado: dataDestaBaixa,
              dataEdicaoImagem: p.DataEdicaoImagem || p.dataEdicaoImagem || p.dataedicaoimagem || p.DataEdicao || p.dataedicao,
            };
          }).filter(p => p.idproduto !== undefined && p.idproduto !== null && p.idproduto !== '' && !Number.isNaN(p.idproduto));

          if (dadosFormatados.length > 0) {
            await db.produto.bulkPut(dadosFormatados);
          }
          
          totalBaixado += dadosFormatados.length;
          item.statusMsg = `Baixando: ${totalBaixado}...`; // Fixado para sempre mostrar "Baixando"

          const ultimoItem = dadosFormatados.length > 0 ? dadosFormatados[dadosFormatados.length - 1] : null;
          if (ultimoItem && (ultimoItem.idcortamanhofinal > 0 || ultimoItem.idproduto > 0)) {
              ultimoIdPagina = ultimoItem.idcortamanhofinal || ultimoItem.idproduto;
          }

          if (dados.length < limitePorPagina) {
            continuar = false;
          }
        } else {
          continuar = false;
        }
      }

      // Mantém a atualização do parâmetro caso algum outro módulo precise da data do último sync
      if (configAtual) {
        const primKey = db.parametro.schema.primKey.name; 
        const keyVal = configAtual[primKey];
        await db.parametro.update(keyVal, { databaixado_produto: dataDestaBaixa });
      }

      item.statusMsg = `Total: ${totalBaixado} produtos`;
    },

    // GRUPOS
    async sincronizarGrupo(item) {
      const paramsDb = await db.parametro.toArray();
      const configAtual = paramsDb.length > 0 ? paramsDb[paramsDb.length - 1] : null;

      let ultimaBaixa = configAtual ? configAtual.databaixado_grupo : null;
      const dataDestaBaixa = new Date();

      const ajustarDataParaLocal = (date) => {
        const offset = date.getTimezoneOffset() * 60000;
        const dataLocal = new Date(date.getTime() - offset);
        return dataLocal.toISOString().slice(0, -1);
      };

      if (ultimaBaixa) ultimaBaixa = new Date(ultimaBaixa);

      if (!ultimaBaixa) {
        await db.grupo.clear();
      } else {
        const margemSeguranca = 30 * 60 * 1000;
        ultimaBaixa = new Date(ultimaBaixa.getTime() - margemSeguranca);
      }
      
      const ultimoGrupo = await db.grupo.orderBy('idgrupo').last();
      const ultimoId = ultimoGrupo ? ultimoGrupo.idgrupo : 0;

      let paramsUrl = `&UltimoId=${ultimoId}`;
      if (ultimaBaixa) {
        const dataFormatada = ajustarDataParaLocal(ultimaBaixa);
        paramsUrl += `&DataAlteracao=${dataFormatada}`;
      }

      let dados = await this.fetchWcf('grupo/lista', paramsUrl);

      if (dados && !Array.isArray(dados) && dados.data) {
        dados = dados.data;
      }

      if (!dados) {
        if (!ultimaBaixa) throw new Error("Sem dados");
        item.statusMsg = "Grupos atualizados";
        return;
      }
      
      if (dados.length === 0) {
        if (!ultimaBaixa) item.statusMsg = "Nenhum grupo encontrado.";
        else item.statusMsg = "Grupos atualizados.";
      } else {
        const dadosFormatados = dados.map(g => ({
          idgrupo: g.idgrupo || g.IdGrupo || g.id,
          descricao: g.descricao || g.Descricao,
          databaixado: dataDestaBaixa
        }))
        .filter(g => g.idgrupo !== undefined && g.idgrupo !== null);

        await db.grupo.bulkPut(dadosFormatados);
        
        item.statusMsg = ultimaBaixa 
            ? `Atualizados: ${dadosFormatados.length}`
            : `Total: ${dadosFormatados.length} grupos`;
      }

      if (configAtual) {
        const primKey = db.parametro.schema.primKey.name; 
        const keyVal = configAtual[primKey];
        await db.parametro.update(keyVal, { 
          databaixado_grupo: dataDestaBaixa 
        });
      }
    },

    // 6. SUGERIDOS
    async sincronizarSugeridos(item) {
      const paramsDb = await db.parametro.toArray();
      const configAtual = paramsDb.length > 0 ? paramsDb[paramsDb.length - 1] : null;

      let ultimaBaixa = configAtual ? configAtual.databaixado_sugerido : null;
      const dataDestaBaixa = new Date();
      
      const params = '';
      const dados = await this.fetchWcf('produtosugerido/', params);

      if (!dados) {
        if (!ultimaBaixa) throw new Error("Sem dados");
        item.statusMsg = "Regras atualizadas";
        return;
      }
      
      await db.produtosugerido.clear();
      
      const dadosFormatados = dados.map(p => ({
        idprodutosugerido: p.IdGrupo || p.idGrupo, 
        idgrupo: p.IdGrupo || p.idGrupo,
        descricao: p.Descricao || p.descricao
      }))
      .filter(p => p.idprodutosugerido !== undefined && p.idprodutosugerido !== null);

      await db.produtosugerido.bulkPut(dadosFormatados);

      item.statusMsg = ultimaBaixa 
      ? `Sugeridos atualizado`
      : `Total: ${dadosFormatados.length} regras`;

      if (configAtual) {
        const primKey = db.parametro.schema.primKey.name; 
        const keyVal = configAtual[primKey];

        await db.parametro.update(keyVal, { 
          databaixado_sugerido: dataDestaBaixa 
        });
      }
    },

    // 7. FORMAS
    async sincronizarFormas(item) {
      const paramsDb = await db.parametro.toArray();
      const configAtual = paramsDb.length > 0 ? paramsDb[paramsDb.length - 1] : null;

      let ultimaBaixa = configAtual ? configAtual.databaixado_forma : null;
      const dataDestaBaixa = new Date();

      const ajustarDataParaLocal = (date) => {
        const offset = date.getTimezoneOffset() * 60000;
        const dataLocal = new Date(date.getTime() - offset);
        return dataLocal.toISOString().slice(0, -1);
      };

      if (ultimaBaixa) ultimaBaixa = new Date(ultimaBaixa);

      if (!ultimaBaixa) {
        await db.formapagto.clear();
      } else {
        const margemSeguranca = 30 * 60 * 1000;
        ultimaBaixa = new Date(ultimaBaixa.getTime() - margemSeguranca);
      }
      
      const ultimaForma = await db.formapagto.orderBy('idformapagto').last();
      const ultimoId = ultimaForma ? ultimaForma.idformapagto : 0;

      let paramsUrl = `&UltimoId=${ultimoId}`;
      if (ultimaBaixa) {
        const dataFormatada = ajustarDataParaLocal(ultimaBaixa);
        paramsUrl += `&DataAlteracao=${dataFormatada}`;
      }
      
      const dados = await this.fetchWcf('formapagto/lista', paramsUrl);

      if (!dados) {
        if (!ultimaBaixa) throw new Error("Sem dados");
        item.statusMsg = "Formas atualizadas";
        return;
      }
      
      if (dados.length === 0) {
        if (!ultimaBaixa) item.statusMsg = "Nenhuma forma encontrada.";
        else item.statusMsg = "Formas atualizadas.";
      } else {
        const dadosFormatados = dados.map(f => ({
          idformapagto: f.IdFormaPagto || f.idFormaPagto || f.id,
          descricao: f.Descricao || f.descricao,
          databaixado: dataDestaBaixa
        }))
        .filter(f => f.idformapagto !== undefined && f.idformapagto !== null);

        await db.formapagto.bulkPut(dadosFormatados);
        
        item.statusMsg = ultimaBaixa 
            ? `Atualizados: ${dadosFormatados.length}`
            : `Total: ${dadosFormatados.length} formas`;
      }

      if (configAtual) {
        const primKey = db.parametro.schema.primKey.name; 
        const keyVal = configAtual[primKey];

        await db.parametro.update(keyVal, { 
          databaixado_forma: dataDestaBaixa 
        });
      }
    },

    // 8. DESTINOS
    async sincronizarDestinos(item) {
      const paramsDb = await db.parametro.toArray();
      const configAtual = paramsDb.length > 0 ? paramsDb[paramsDb.length - 1] : null;

      let ultimaBaixa = configAtual ? configAtual.databaixado_destino : null;
      const dataDestaBaixa = new Date();

      const ajustarDataParaLocal = (date) => {
        const offset = date.getTimezoneOffset() * 60000;
        const dataLocal = new Date(date.getTime() - offset);
        return dataLocal.toISOString().slice(0, -1);
      };

      if (ultimaBaixa) ultimaBaixa = new Date(ultimaBaixa);

      if (!ultimaBaixa) {
        if (db.destinoitem) await db.destinoitem.clear();
        else if (db.destinoitemvenda) await db.destinoitemvenda.clear();
      } else {
        const margemSeguranca = 30 * 60 * 1000;
        ultimaBaixa = new Date(ultimaBaixa.getTime() - margemSeguranca);
      }
      
      let ultimoId = 0;
      if (db.destinoitem) {
        const ultimo = await db.destinoitem.orderBy('iddestinoitem').last();
        if (ultimo) ultimoId = ultimo.iddestinoitem;
      } else if (db.destinoitemvenda) {
        const ultimo = await db.destinoitemvenda.orderBy('iddestinoitem').last();
        if (ultimo) ultimoId = ultimo.iddestinoitem;
      }

      let paramsUrl = `&UltimoId=${ultimoId}`;
      if (ultimaBaixa) {
        const dataFormatada = ajustarDataParaLocal(ultimaBaixa);
        paramsUrl += `&DataAlteracao=${dataFormatada}`;
      }

      const dados = await this.fetchWcf('destinoitemvenda/', paramsUrl);

      if (!dados) {
        if (!ultimaBaixa) throw new Error("Sem dados");
        item.statusMsg = "Destinos atualizados";
        return;
      }
      
      if (dados.length === 0) {
        if (!ultimaBaixa) item.statusMsg = "Nenhum destino encontrado.";
        else item.statusMsg = "Destinos atualizados.";
      } else {
        const dadosFormatados = dados.map(d => ({
          id: d.IdDestinoItem || d.IdDestinoItemVenda || d.id, 
          iddestinoitem: d.IdDestinoItem || d.IdDestinoItemVenda || d.id,
          descricao: d.Descricao || d.descricao,
          databaixado: dataDestaBaixa
        }))
        .filter(d => d.iddestinoitem !== undefined && d.iddestinoitem !== null);

        if (db.destinoitem) await db.destinoitem.bulkPut(dadosFormatados);
        else if (db.destinoitemvenda) await db.destinoitemvenda.bulkPut(dadosFormatados);
        
        item.statusMsg = ultimaBaixa 
            ? `Atualizados: ${dadosFormatados.length}`
            : `Total: ${dadosFormatados.length} destinos`;
      }

      if (configAtual) {
        const primKey = db.parametro.schema.primKey.name; 
        const keyVal = configAtual[primKey];

        await db.parametro.update(keyVal, { 
          databaixado_destino: dataDestaBaixa 
        });
      }
    },

    // 9. IMAGEM
    async sincronizarImagens(item) {
      const produtosComImagem = await db.produto
        .filter(p => p.temImagem === 'S' || p.temImagem === true)
        .toArray();

      if (produtosComImagem.length === 0) {
        item.statusMsg = 'Nenhuma imagem para baixar';
        item.done = true;
        return;
      }

      const imagensParaBaixar = [];
      for (const p of produtosComImagem) {
        if (this.abortController.signal.aborted) throw new Error('Cancelado');

        let cache = null;
        if (p.idcortamanhofinal) {
          const idCtfNum = Number(p.idcortamanhofinal);
          if (!isNaN(idCtfNum)) {
            cache = await db.imagem.where('idcortamanhofinal').equals(idCtfNum).first();
          }
          if (!cache) {
            cache = await db.imagem.where('idcortamanhofinal').equals(String(p.idcortamanhofinal)).first();
          }
        }
        let precisaBaixar = false;

        if (!cache || !cache.dataDownloadImagem) {
          precisaBaixar = true;
        } else {
          if (p.dataEdicaoImagem) {
            const dataServidor = new Date(p.dataEdicaoImagem);
            const dataLocal = new Date(cache.dataDownloadImagem);
            if (dataServidor > dataLocal) {
              precisaBaixar = true;
            }
          }
          if (!precisaBaixar) {
            for (let i = 1; i <= 10; i++) {
              const nomeImagemNaColuna = p[`imagem${i}`];
              if (nomeImagemNaColuna && nomeImagemNaColuna.trim() !== '') {
                if (!cache[`imgBlob${i}`]) {
                  precisaBaixar = true;
                  break;
                }
              }
            }
          }
        }

        if (precisaBaixar) {
          imagensParaBaixar.push({ prod: p, cache });
        }
      }

      const total = imagensParaBaixar.length;
      
      if (total === 0) {
        item.statusMsg = 'Imagens atualizadas';
        item.done = true;
        return;
      }

      let baixados = 0;
      const CONCURRENCY_LIMIT = 3;

      const downloadImagem = async ({ prod, cache }) => {
        const updates = {};

        for (let i = 1; i <= 10; i++) {
            if (this.abortController.signal.aborted) break;

            const nomeImagemNaColuna = prod[`imagem${i}`];
            const campoBlob = `imgBlob${i}`;

            if (nomeImagemNaColuna && nomeImagemNaColuna.trim() !== '') {
                try {
                    const url = `${this.baseUrl}produto/${prod.idcortamanhofinal}/imagem/${i}?ChaveSistema=m1cr0s3rv&_t=${new Date().getTime()}`;
                    
                    const response = await fetch(url, { 
                        signal: this.abortController.signal 
                    });

                    if (response.status === 404) {
                        updates[campoBlob] = null;
                    } 
                    else if (response.ok) {
                        const contentType = response.headers.get('content-type');
                        
                        if (contentType && contentType.includes('application/json')) {
                            const erroJson = await response.json();
                            console.warn(`Erro API Imagem (Prod ${prod.idcortamanhofinal}):`, erroJson);
                        } else {
                            const blob = await response.blob();
                            
                            if (blob.size > 0) {
                                updates[campoBlob] = blob;
                            }
                        }
                    } 
                } catch (err) {
                    if (err.name !== 'AbortError') {
                        console.warn(`Falha ao baixar imagem ${i} do produto ${prod.idcortamanhofinal}`, err);
                    }
                }
            } else {
                if (cache && cache[campoBlob]) {
                    updates[campoBlob] = null;
                }
            }
        }

        const dataDownload = new Date();
        const dataAlteracaoImagem = prod.dataEdicaoImagem || prod.DataEdicaoImagem || prod.DataEdicao || null;

        if (cache) {
          await db.imagem.where('id').equals(cache.id).modify({
            ...updates,
            dataalteracao: dataAlteracaoImagem,
            dataDownloadImagem: dataDownload
          });
        } else {
          await db.imagem.add({
            idproduto: prod.idproduto,
            idcortamanhofinal: prod.idcortamanhofinal,
            dataalteracao: dataAlteracaoImagem,
            ...updates,
            dataDownloadImagem: dataDownload
          });
        }
        baixados++;
        
        item.statusMsg = `Baixando imagens: ${baixados} / ${total}`;
      };

      for (let i = 0; i < total; i += CONCURRENCY_LIMIT) {
        if (this.abortController.signal.aborted) throw new Error('Cancelado');
        const lote = imagensParaBaixar.slice(i, i + CONCURRENCY_LIMIT);
        await Promise.all(lote.map(p => downloadImagem(p)));
      }

      item.statusMsg = `Imagens atualizadas`;
    },

    // 10. VENDAS
    async sincronizarVendas(item) {
      const paramsDb = await db.parametro.toArray();
      const configAtual = paramsDb.length > 0 ? paramsDb[paramsDb.length - 1] : null;
      
      let ultimaBaixa = configAtual ? configAtual.databaixado_vendas : null;

      const dataDestaBaixa = new Date();

      const idVendedorLogado = (configAtual && configAtual.idvendedorlogado) ? configAtual.idvendedorlogado : this.idVendedor;

      const ultimoVendedorSincronizado = configAtual ? configAtual.vendedor_sync_venda : null;

      if (ultimoVendedorSincronizado !== idVendedorLogado) {
        ultimaBaixa = null;
        await db.venda.clear();
      }

      const ajustarDataParaLocal = (date) => {
        const offset = date.getTimezoneOffset() * 60000;
        const dataLocal = new Date(date.getTime() - offset);
        return dataLocal.toISOString().slice(0, -1);
      };

      if (ultimaBaixa) {
        ultimaBaixa = new Date(ultimaBaixa);
        const margemSeguranca = 24 * 60 * 60 * 1000;
        ultimaBaixa = new Date(ultimaBaixa.getTime() - margemSeguranca);
      } else {
        await db.venda.clear();
      }

      let ultimoId = 0;
      if (ultimaBaixa) {
        const ultimaVenda = await db.venda.orderBy('idvenda').last();
        if (ultimaVenda && ultimaVenda.idvenda) {
          ultimoId = ultimaVenda.idvenda;
        }
      }

      const vendasLocaisExistentes = await db.venda.toArray();
      const mapLocaisItens = new Map();
      const mapLocaisPedItens = new Map();
      const mapLocaisVendaCtf = new Map();

      vendasLocaisExistentes.forEach(v => {
        if (v.iditensvenda) mapLocaisItens.set(v.iditensvenda, v);
        if (v.idpedidovendaitens) mapLocaisPedItens.set(v.idpedidovendaitens, v);
        if (v.idvenda && v.idcortamanhofinal) {
          mapLocaisVendaCtf.set(`${v.idvenda}_${v.idcortamanhofinal}`, v);
        }
      });

      let paginaAtual = 1;
      const limitePorPagina = 1000;
      let totalBaixado = 0;
      let continuar = true;

      const paramDataCarga = await this.obterParametroDataCarga();

      while (continuar) {
        let paramsUrl = `&page=${paginaAtual}&limit=${limitePorPagina}&UltimoId=${ultimoId}&IdVendedor=${idVendedorLogado}`;

        if (ultimaBaixa) {
          const dataFormatada = ajustarDataParaLocal(ultimaBaixa);
          paramsUrl += `&DataAlteracao=${dataFormatada}`;
        }

        paramsUrl += paramDataCarga;

        let dados = await this.fetchWcf('venda/geral', paramsUrl);

        if (dados && !Array.isArray(dados) && dados.data) {
          dados = dados.data;
        }

        if (dados && dados.length > 0) {
          const dadosFormatados = dados.map(v => {
            const idVenda = v.IdVenda || v.idvenda;
            const idItensVenda = v.iditensvenda || v.IdItensVenda;
            const idPedItens = v.IDPedidoVendaItens || v.IdPedidoVendaItens || v.idpedidovendaitens;
            const idCtf = v.IdCorTamanhoFinal || v.idcortamanhofinal;

            let local = null;
            if (idItensVenda) local = mapLocaisItens.get(idItensVenda);
            if (!local && idPedItens) local = mapLocaisPedItens.get(idPedItens);
            if (!local && idVenda && idCtf) local = mapLocaisVendaCtf.get(`${idVenda}_${idCtf}`);

            return {
              ...(local ? { idlocal: local.idlocal } : {}),
              idvenda: idVenda, 
              iditensvenda: idItensVenda,
              idcliente: v.IdCliente || v.idcliente,
              idvendedor: v.IdVendedor || v.idvendedor,
              descricao: v.Descricao || v.descricao || 'Venda sem descrição', 
              idcortamanhofinal: idCtf,
              data: v.Data || v.data || v.datavenda,
              qtde: v.Qtde || v.qtde || 1, 
              valor: v.Valor || v.valor || v.vlrtotalliquido,
              cidade: v.Cidade || v.cidade,
              cancelado: v.Cancelado,
              idpedidovendaitens: idPedItens || null,
              idempresa: v.ID_Empresa || v.IdEmpresa || v.idempresa || v.idEmpresa || null,
              databaixado: dataDestaBaixa,

              percdescontovenda: v.PercDescontoVenda,
              vlrdescontovenda: v.vlrDescontoVenda,
              vlrfretevenda: v.vlrFreteVenda,
              vlrdespvenda: v.vlrDespVenda,
              vlrliquidovenda: v.vlrLiquidoVenda,
              subtotalvenda: v.SubTotalVenda,
              despesaquantidade: v.DespesaQuantidade,
              despesapesoliquido: v.DespesaPesoLiquido,
              despesapesobruto: v.DespesaPesoBruto,
              perccomissaovendedor: v.PercComissaoVendedor,
              vlrcomissaovendedor: v.VlrComissaoVendedor,
            };
          })
          .filter(v => v.idvenda !== undefined && v.idvenda !== null);

          if (dadosFormatados.length > 0) {
            await db.venda.bulkPut(dadosFormatados);
          }

          totalBaixado += dadosFormatados.length;

          item.statusMsg = ultimaBaixa 
            ? `Atualizando: ${totalBaixado}...`
            : `Baixando: ${totalBaixado}...`;

          if (dados.length < limitePorPagina) {
            continuar = false;
          } else {
            paginaAtual++;
          }
        } else {
          continuar = false;
        }
      }
      
      if (ultimaBaixa) {
        item.statusMsg = totalBaixado > 0 
          ? `Atualizados: ${totalBaixado}` 
          : 'Vendas atualizadas';
      } else {
          item.statusMsg = `Total: ${totalBaixado} registros`;
      }

      if (configAtual) {
        const primKey = db.parametro.schema.primKey.name; 
        const keyVal = configAtual[primKey];
        
        await db.parametro.update(keyVal, { 
          databaixado_vendas: dataDestaBaixa,
          vendedor_sync_venda: idVendedorLogado
        });
      }
    },

    // 12. ATUALIZAÇÃO DE PEDIDOS
    async atualizaPedido(item) {
      if (item) item.statusMsg = 'Verificando status locais...';

      const pedidosLocaisParaAtualizar = await db.pedido
        .filter(p => 
          p.idpedidoback && 
          p.idpedidoback > 0 && 
          !p.datafaturamento && 
          !p.datacancelamento
        )
        .toArray();

      if (pedidosLocaisParaAtualizar.length > 0) {
        const idsPedidos = pedidosLocaisParaAtualizar.map(p => p.idpedidoback);

        if (!this.baseUrl) {
          await this.carregarConfiguracoes();
        }
        const urlStatus = `${this.baseUrl}pedido/atualiza-status?ChaveSistema=m1cr0s3rv`;
        
        const headers = { 'Content-Type': 'application/json' };

        try {
          const registroEmpresa = await db.empresa.limit(1).first();
          if (registroEmpresa && registroEmpresa.EMPChaveAppVenda) {
            headers['Authorization'] = registroEmpresa.EMPChaveAppVenda;
          }
        } catch (err) { 
          //sad
        }

        const response = await fetch(urlStatus, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(idsPedidos),
          signal: this.abortController.signal
        });

        if (response.ok) {
          const dadosServidor = await response.json();
          if (dadosServidor && dadosServidor.length > 0) {
            const atualizacoes = [];

            for (const dadoAPI of dadosServidor) {
              const updateData = {};
              const pedidoLocal = pedidosLocaisParaAtualizar.find(p => p.idpedidoback === dadoAPI.idpedido);
              const tempoEnvio = (pedidoLocal && pedidoLocal.dataenvio) ? new Date(pedidoLocal.dataenvio).getTime() : 0;

              if (dadoAPI.dataconfirmacao !== undefined) updateData.dataconfirmacao = dadoAPI.dataconfirmacao;
              if (dadoAPI.datafaturamento) {
                const tempoFat = new Date(dadoAPI.datafaturamento).getTime();
                if (tempoFat > tempoEnvio) updateData.datafaturamento = dadoAPI.datafaturamento;
              }
              if (dadoAPI.datacancelamento) {
                const tempoCanc = new Date(dadoAPI.datacancelamento).getTime();
                if (tempoCanc > tempoEnvio) updateData.datacancelamento = dadoAPI.datacancelamento;
              }

              if (Object.keys(updateData).length > 0) {
                atualizacoes.push(
                  db.pedido.where('idpedidoback').equals(dadoAPI.idpedido).modify(updateData)
                );
              }
            }
            await Promise.all(atualizacoes);
          }
        }
      }

      if (item) item.statusMsg = 'Baixando histórico...';

      const paramsDb = await db.parametro.toArray();
      const configAtual = paramsDb.length > 0 ? paramsDb[paramsDb.length - 1] : null;

      const dataDestaBaixa = new Date();
      const idVendedorLogado = (configAtual && configAtual.idvendedorlogado) ? configAtual.idvendedorlogado : this.idVendedor;
      
      let ultimaBaixa = configAtual ? configAtual.databaixado_pedido : null;
      const ultimoVendedorSincronizado = configAtual ? configAtual.vendedor_sync_pedido : null;

      let resetarUltimoId = false;

      if (ultimoVendedorSincronizado !== idVendedorLogado) {
        ultimaBaixa = null;
        resetarUltimoId = true;
        
        if (item) item.statusMsg = 'Limpando dados do vendedor anterior...';

        const pedidosParaLimpar = await db.pedido
          .filter(p => !!p.datalimpeza)
          .toArray();

        if (pedidosParaLimpar.length > 0) {
          const pkName = db.pedido.schema.primKey.name;
          const chavesParaApagar = pedidosParaLimpar.map(p => p[pkName]).filter(id => id !== undefined);

          if (chavesParaApagar.length > 0) {
            await db.pedido.bulkDelete(chavesParaApagar);
          }

          const idsParaFk = pedidosParaLimpar.map(p => p.idpedido || p.id).filter(id => id !== undefined);
          if (idsParaFk.length > 0) {
            try {
              await db.pedidoitem.where('idpedido').anyOf(idsParaFk).delete();
            } catch (e) {
              // Silencia erros caso não encontre
            }
          }
        }
      }

      const ajustarDataParaLocal = (date) => {
        const offset = date.getTimezoneOffset() * 60000;
        return new Date(date.getTime() - offset).toISOString().slice(0, -1);
      };

      if (ultimaBaixa) {
        const margemSeguranca = 24 * 60 * 60 * 1000;
        ultimaBaixa = new Date(ultimaBaixa.getTime() - margemSeguranca);
      }

      let ultimoIdBack = 0;
      if (!resetarUltimoId && !ultimaBaixa) {
        const todosPedidosLocais = await db.pedido.toArray();
        ultimoIdBack = todosPedidosLocais.reduce((max, p) => (p.idpedidoback > max ? p.idpedidoback : max), 0);
      }

      let paginaAtual = 1;
      const limitePorPagina = 2000;
      let totalBaixado = 0;
      let continuar = true;

      const paramDataCarga = await this.obterParametroDataCarga();

      while(continuar) {
        let paramsUrl = `&page=${paginaAtual}&limit=${limitePorPagina}&UltimoId=${ultimoIdBack}&IdVendedor=${idVendedorLogado}`;

        if (ultimaBaixa) {
          const dataFormatada = ajustarDataParaLocal(ultimaBaixa);
          paramsUrl += `&DataAlteracao=${dataFormatada}`;
        }

        paramsUrl += paramDataCarga;

        let dadosHistorico = await this.fetchWcf('pedido/todos', paramsUrl);

        if (dadosHistorico && !Array.isArray(dadosHistorico) && dadosHistorico.data) {
          dadosHistorico = dadosHistorico.data;
        }

        if (dadosHistorico && dadosHistorico.length > 0) {
          const pedidosLocaisExistentes = await db.pedido.where('idpedidoback').above(0).toArray();
          const mapLocais = new Map(pedidosLocaisExistentes.map(p => [p.idpedidoback, p]));

          const pedidosParaSalvar = dadosHistorico.map(p => {
            const local = mapLocais.get(p.IdPedido);

            const totalCalculado = (p.ListaItem && Array.isArray(p.ListaItem)) 
              ? p.ListaItem.reduce((soma, itemServidor) => {
                  if (itemServidor.DT_Cancelado) {
                    return soma;
                  }
                  return soma + (parseFloat(itemServidor.ValorTotal));
                }, 0)
              : 0;

            return {
              ...(local ? local : {}), 
              idpedidoback: p.IdPedido,
              idcliente: p.ID_Cliente,
              data: p.DT_Pedido,
              idtipopedidovenda: p.IDTIPOPEDIDO,
              atendido: 1,
              idvendedor: p.ID_Representante,
              idempresa: p.ID_Empresa,
              idplanopagamento: p.ID_PlanoPagamento,
              idformapagamento: p.ID_FormaPagamento,
              observacao: p.Observacao,
              observacaovaifatura: p.observacaovaifatura,
              modalidadefrete: p.modalidadefrete,
              nm_modalidadefrete: p.nm_modalidadefrete,
              calculaimposto: p.CalculaImposto,
              pedidoempenho: p.PedidoEmpenho,
              pe_comissao: p.PE_Comissao,
              dataconfirmacao: p.DataConfirmacao,
              datacancelamento: p.DataCancelamento,
              datafaturamento: p.DataFaturamentoFinal || p.DataFaturamento,
              total: totalCalculado,
              databaixado: dataDestaBaixa
            };
          });

          await db.pedido.bulkPut(pedidosParaSalvar);

          const idsPedidosBackSalvos = pedidosParaSalvar.map(p => p.idpedidoback);
          const pedidosAtualizados = await db.pedido.where('idpedidoback').anyOf(idsPedidosBackSalvos).toArray();
          const mapIdsLocais = new Map(pedidosAtualizados.map(p => [p.idpedidoback, p.idpedido || p.id]));
          
          const idsLocais = Array.from(mapIdsLocais.values()).filter(id => id !== undefined);
          if (idsLocais.length > 0) {
            try { await db.pedidoitem.where('idpedido').anyOf(idsLocais).delete(); } catch (e) { 
              //das
            } 
          }

          let itensParaSalvar = [];
          dadosHistorico.forEach(p => {
            if (p.ListaItem && p.ListaItem.length > 0) {
              const idLocal = mapIdsLocais.get(p.IdPedido);
              
              p.ListaItem.forEach(itemServidor => {
                itensParaSalvar.push({
                  idpedido: idLocal, 
                  idpedidoback: p.IdPedido,
                  idcortamanhofinal: itemServidor.ID_CorTamanhoFinal,
                  atendido: 1,
                  ordem: itemServidor.NO_Item,
                  valorunitario: itemServidor.VL_Unitario,
                  quantidade: itemServidor.QT_Produto,
                  valordesconto: itemServidor.VL_Desconto,
                  observacao: itemServidor.ObservacaoItem,
                  valorliquido: itemServidor.VL_Liquido,
                  percdesconto: itemServidor.PE_Desconto,
                  movimentacaokit: itemServidor.MovimentacaoKit || 'N',
                  pedidoempenho: itemServidor.PedidoEmpenho || 'N',
                  valortotal: itemServidor.ValorTotal,
                  pvivlrpromocaoclube: itemServidor.PVIVlrPromocaoClube,
                  pviqtdepromocaoclube: itemServidor.PVIQtdePromocaoClube,
                  DT_Cancelado: itemServidor.DT_Cancelado || null,
                  DataFaruramentoItem: itemServidor.DataFaruramentoItem || itemServidor.DataFaturamentoItem || null
                });
              });
            }
          });

          if (itensParaSalvar.length > 0) {
            await db.pedidoitem.bulkPut(itensParaSalvar);
          }

          totalBaixado += dadosHistorico.length;
          if (item) item.statusMsg = `Baixando: ${totalBaixado}...`;

          if (dadosHistorico.length < limitePorPagina) {
            continuar = false;
          } else {
            paginaAtual++;
          }
        } else {
          continuar = false;
        }
      }

      if (ultimaBaixa) {
          if (item) item.statusMsg = totalBaixado > 0 ? `Atualizados: ${totalBaixado}` : 'Pedidos atualizados';
      } else {
          if (item) item.statusMsg = `Total: ${totalBaixado} pedidos baixados`;
      }

      if (configAtual) {
        const primKey = db.parametro.schema.primKey.name;
        const keyVal = configAtual[primKey];

        await db.parametro.update(keyVal, {
          databaixado_pedido: dataDestaBaixa,
          vendedor_sync_pedido: idVendedorLogado
        });
      }
    },

    // 11. FINANCEIRO
    async sincronizarFinanceiro(item) {
      const paramsDb = await db.parametro.toArray();
      const configAtual = paramsDb.length > 0 ? paramsDb[paramsDb.length - 1] : null;
      
      let ultimaBaixa = configAtual ? configAtual.databaixado_financeiro : null;

      const dataDestaBaixa = new Date();

      const idVendedorLogado = (configAtual && configAtual.idvendedorlogado) ? configAtual.idvendedorlogado : this.idVendedor;

      const ultimoVendedorSincronizado = configAtual ? configAtual.vendedor_sync_financeiro : null;

      if (ultimoVendedorSincronizado !== idVendedorLogado) {
        ultimaBaixa = null;
        await db.financeiro.clear();
      }

      const ajustarDataParaLocal = (date) => {
        const offset = date.getTimezoneOffset() * 60000;
        const dataLocal = new Date(date.getTime() - offset);
        return dataLocal.toISOString().slice(0, -1);
      };

      if (ultimaBaixa) {
        ultimaBaixa = new Date(ultimaBaixa);
        const margemSeguranca = 24 * 60 * 60 * 1000;
        ultimaBaixa = new Date(ultimaBaixa.getTime() - margemSeguranca);
      } else {
        await db.financeiro.clear();
      }

      let ultimoId = 0;
      if (ultimaBaixa) {
        const ultimoFinanceiro = await db.financeiro.orderBy('idfinanceiro').last();
        if (ultimoFinanceiro && ultimoFinanceiro.idfinanceiro) {
          ultimoId = ultimoFinanceiro.idfinanceiro;
        }
      }

      let paginaAtual = 1;
      const limitePorPagina = 2000;
      let totalBaixado = 0;
      let continuar = true;

      const paramDataCarga = await this.obterParametroDataCarga();

      while (continuar) {
        let paramsUrl = `&page=${paginaAtual}&limit=${limitePorPagina}&UltimoId=${ultimoId}&IdVendedor=${idVendedorLogado}`;

        if (ultimaBaixa) {
          const dataFormatada = ajustarDataParaLocal(ultimaBaixa);
          paramsUrl += `&DataAlteracao=${dataFormatada}`;
        }

        paramsUrl += paramDataCarga;

        let dados = await this.fetchWcf('financeiro/lista', paramsUrl);

        if (dados && !Array.isArray(dados) && dados.data) {
          dados = dados.data;
        }

        if (dados && dados.length > 0) {
          const dadosFormatados = dados.map(f => ({
            idfinanceiro: f.IdFinanceiro || f.idfinanceiro || f.DREC_ID || f.id,
            idcliente: f.IdCliente || f.idcliente || f.DVEN_idcliente,
            documento: f.Documento || f.documento,
            parcela: f.Parcela || f.parcela,
            tipo: f.Tipo || f.tipo,
            especie: f.Especie || f.especie,
            emissao: f.Emissao || f.emissao,
            vencimento: f.Vencimento || f.vencimento,
            saldo: f.Saldo || f.saldo,
            datafinal: f.DataFinal || f.datafinal,
            databaixado: dataDestaBaixa
          }))
          .filter(f => f.idfinanceiro !== undefined && f.idfinanceiro !== null);

          if (dadosFormatados.length > 0) {
            await db.financeiro.bulkPut(dadosFormatados);
          }

          totalBaixado += dadosFormatados.length;

          item.statusMsg = ultimaBaixa 
            ? `Atualizando: ${totalBaixado}...`
            : `Baixando: ${totalBaixado}...`;

          if (dados.length < limitePorPagina) {
            continuar = false;
          } else {
            paginaAtual++;
          }
        } else {
          continuar = false;
        }
      }

      if (ultimaBaixa) {
        item.statusMsg = totalBaixado > 0 
          ? `Atualizados: ${totalBaixado}` 
          : 'Financeiro atualizado';
      } else {
        item.statusMsg = `Total: ${totalBaixado} títulos`;
      }

      if (configAtual) {
        const primKey = db.parametro.schema.primKey.name; 
        const keyVal = configAtual[primKey];

        await db.parametro.update(keyVal, { 
          databaixado_financeiro: dataDestaBaixa,
          vendedor_sync_financeiro: idVendedorLogado
        });
      }
    },
  },
};
</script>